import { Navigate, RouteObject } from "react-router";
import { OfferIndexRoute } from "@/routes/processes/[processId]/qpm/offers/_components/offer-index-route";
import { OfferRoute } from "@/routes/processes/[processId]/qpm/offers/[offerId]/offer-route";
import { OfferNavLinkType } from "@/services/backend/qpm/offers/types/offer-enum";
import { OfferOverviewComponent } from "@/routes/processes/[processId]/qpm/offers/[offerId]/overview/offer-overview-component";
import { AddressesRoute } from "@/routes/processes/[processId]/qpm/offers/[offerId]/addresses/addresses-route";
import { RepresentativeRoute } from "@/routes/processes/[processId]/qpm/offers/[offerId]/representative/representative-route";
import { CoverLetterRoute } from "@/routes/processes/[processId]/qpm/offers/[offerId]/coverletter/cover-letter-route";
import { TextBlocksRoute } from "@/routes/processes/[processId]/qpm/offers/[offerId]/textblocks/text-blocks";
import { OfferAdditionalInfoRoute } from "@/routes/processes/[processId]/qpm/offers/[offerId]/additional-info/additional-info-route";
import { OfferPestsRoute } from "@/routes/processes/[processId]/qpm/offers/[offerId]/pests/offer-pests-route";
import { OfferContractRoute } from "@/routes/processes/[processId]/qpm/offers/[offerId]/contract/offer-contract-route";
import { OfferServiceProgramRoute } from "@/routes/processes/[processId]/qpm/offers/[offerId]/service-program/offer-service-program-route";

export const offersRoutes: RouteObject[] = [
  {
    index: true,
    element: <OfferIndexRoute />,
  },
  {
    path: ":offerId",
    element: <OfferRoute />,
    children: [
      {
        index: true,
        element: <Navigate to={OfferNavLinkType.Overview} replace />,
      },
      {
        path: OfferNavLinkType.Overview,
        element: <OfferOverviewComponent />,
      },
      {
        path: OfferNavLinkType.Contract,
        element: <OfferContractRoute />,
      },
      {
        path: OfferNavLinkType.ServiceProgram,
        element: <OfferServiceProgramRoute />,
      },
      {
        path: OfferNavLinkType.Pests,
        element: <OfferPestsRoute />,
      },
      {
        path: OfferNavLinkType.Addresses,
        element: <AddressesRoute />,
      },
      {
        path: OfferNavLinkType.Representative,
        element: <RepresentativeRoute />,
      },
      {
        path: OfferNavLinkType.CoverLetter,
        element: <CoverLetterRoute />,
      },
      {
        path: OfferNavLinkType.TextBlocks,
        element: <TextBlocksRoute />,
      },
      {
        path: OfferNavLinkType.AdditionalInfo,
        element: <OfferAdditionalInfoRoute />,
      },
    ],
  },
];
